/*
 * File: CreateTimeSlots.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Converts an array of times to a time slot dictionary.
 * Currently it assumes that the data is set to one day.  This may change
 *
 * * @param {array} data An array of Appointments
 * @param {string} dateStringName Name of the data object key to assign as the dictionary key
 * @return {Array}
 */

import { format, compareAsc, compareDesc } from "date-fns";

const CreateTimeSlots = (data, dateStringName, order) => {
  const timeSlots = data.sort((a, b) => {
    if (order === "asc") {
      return compareAsc(a[dateStringName], b[dateStringName]);
    } else {
      return compareDesc(a[dateStringName], b[dateStringName]);
    }
  });

  // add timeslots
  return timeSlots.reduce((timeSlot, appt) => {
    const key = format(appt[dateStringName], "h:mm a");

    if (!timeSlot[key]) {
      timeSlot[key] = [appt];
    } else {
      timeSlot[key] = [...timeSlot[key], appt];
    }
    return timeSlot;
  }, {});
};

export default CreateTimeSlots;
